/* Scroll reveal + 3D CTA wrap */
(function(){
  /* Reveal on scroll */
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        e.target.classList.add('vis');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.06 });
  document.querySelectorAll('.rv').forEach(function(el){ obs.observe(el) });

  /* 3D CTA wrap */
  function wrap3D(btn){
    if (btn.parentElement && btn.parentElement.classList.contains('cta-3d-wrap')) return;
    var wrap = document.createElement('span');
    wrap.className = 'cta-3d-wrap';
    if (btn.classList.contains('prod-cta') || btn.classList.contains('sb-cta')) {
      wrap.classList.add('cta-3d-wrap--full');
    }
    btn.parentNode.insertBefore(wrap, btn);
    wrap.appendChild(btn);
  }
  document.querySelectorAll('.mn-cta,.nav-cta,.btn-big,.prod-cta,.pdp-add-btn,.sb-cta.ready').forEach(wrap3D);
})();
